import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useDoctorQuery } from '../../hooks/useDoctorQuery';
import { useDoctorContext } from '../../context/DoctorContext';
import { FaFacebook, FaInstagram, FaLinkedin, FaTwitter } from 'react-icons/fa';
import { useLanguage } from '../../context/LanguageContext';

export default function Footer() {
    const { t } = useLanguage();
    const { data: doctor } = useDoctorQuery();
    const { slug } = useParams();
    const navigate = useNavigate();
    const {
        hasClinics,
        hasServices,
        hasBlogs,
        hasOffers,
    } = useDoctorContext();

    // Helper function to scroll to section
    const scrollToSection = (id) => {
        const currentPath = window.location.pathname;
        const homePath = `/${slug}`;

        if (currentPath !== homePath && currentPath !== `${homePath}/home`) {
            // Navigate to home first, then scroll
            navigate(homePath);
            setTimeout(() => {
                const element = document.getElementById(id);
                if (element) {
                    const offset = window.innerWidth > 768 ? 100 : 250;
                    const y = element.getBoundingClientRect().top + window.scrollY - offset;
                    window.scrollTo({ top: y, behavior: "smooth" });
                }
            }, 300);
        } else {
            // Already on home page, just scroll
            const element = document.getElementById(id);
            if (element) {
                const offset = window.innerWidth > 768 ? 100 : 250;
                const y = element.getBoundingClientRect().top + window.scrollY - offset;
                window.scrollTo({ top: y, behavior: "smooth" });
            }
        }
    };

    // Quick links based on available sections
    const quickLinks = [
        { label: t("navigation.about"), id: "counter" },
        { label: t("navigation.testimonials"), id: "testimonials" },
        { label: t("navigation.contactUs"), id: "contact" },
    ].filter(Boolean);

    return (
        <footer className="bg-textPrimary text-white p-6 md:p-8">
            <div className=" mx-auto grid grid-cols-1 md:grid-cols-3 gap-8">
                {/* Doctor Info */}
                <div>
                    <h1 className="text-2xl font-bold mb-2">
                        {t('common.dr')} {doctor?.fullName }
                    </h1>
                    <p className="text-sm">
                        {doctor?.slogan }
                    </p>
                </div>

                {/* Quick Links */}
                <div>
                    <h2 className="text-lg font-semibold mb-2">{t("footer.quickLinks")}</h2>
                    <ul className="space-y-1 text-sm">
                        {quickLinks.map((link) => (
                            <li key={link.id}>
                                <button
                                    onClick={() => scrollToSection(link.id)}
                                    className="hover:underline hover:text-teal-300 transition-colors text-left"
                                >
                                    {link.label}
                                </button>
                            </li>
                        ))}
                    </ul>
                </div>

                {/* Contact Info */}
                {!doctor?.isLocked && (
                    <div>
                        <h2 className="text-lg font-semibold mb-2">{t('footer.contactSection')}</h2>
                        <ul className="space-y-1 text-sm">
                            <li>{t('footer.phone')}: {doctor?.phoneNumber || ''}</li>
                            <li>{t('footer.email')}: {doctor?.email || 'dr.michelle@therapy.com'}</li>
                        </ul>
                       
                    </div>
                )}
            </div>
            {/* Copyright */}
            <div className="mt-8 text-center text-sm border-t pt-4">
                {t('footer.copyright')}
            </div>
        </footer>
    );
}